import { Injectable } from '@angular/core';
import { CustomHttp } from '../shared/custom.http';
import 'rxjs/add/operator/toPromise';
import { User } from './user';
import { Router } from '@angular/router';


@Injectable()
export class UserService {

  public currentUser;

  private usersUrl = '/user';  // URL to web api

  constructor(private router: Router, private http: CustomHttp) { }

  getRoles() {
    const url = `/role`;
    return this.http.get(url, { body: '' });
  }

  getAccounts() {
    const url = `/account`;
    return this.http.get(url, { body: '' });
  }

  getUsers() {
    const url = `${this.usersUrl}/all`;
    return this.http.get(url, { body: '' });
  }

  getOwnUser() {
    return this.http.get(this.usersUrl, { body: '' });
  }

  getUser(user_id: number) {
    const url = `${this.usersUrl}?userId=${user_id}`;
    return this.http.get(url, { body: '' });
  }

  delete(user: User) {
    const url = `${this.usersUrl}?userId=${user.user_id}`;
    return this.http
      .delete(url, { body: '' });
  }

  // Add new User
  createUser(user: User): Promise<User> {
    const url = `${this.usersUrl}`;
    return this.http
      .post(url, JSON.stringify(user));
  }

  // Update existing user
  updateUser(user: User) {
    const url = `${this.usersUrl}?userId=${user.user_id}`;
    return this.http
      .put(url, JSON.stringify(user));
  }

  isExternalUser() {
    if ( !this.currentUser ) {
      return false;
    }
    const result = this.currentUser.user_roles.filter(x => x.role_name === 'External Harvester');
    return (result !== undefined && result.length > 0);
  }

  isHelpdeskAdmin() {
    if ( !this.currentUser ) {
      return false;
    }
    const result = this.currentUser.user_roles.filter(x => x.role_name === 'DP Admin');
    return (result !== undefined && result.length > 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user.service.ts